import {PlanFactTableDataGroupedByMonths} from '../types/table-data.types';

export const dataGroupedByMonths: Array<PlanFactTableDataGroupedByMonths> = [
  {
    monthNumber: 1,
    monthName: 'Январь',
    planFactData: null
  },
  {
    monthNumber: 2,
    monthName: 'Февраль',
    planFactData: null
  },
  {
    monthNumber: 3,
    monthName: 'Март',
    planFactData: null
  },
  {
    monthNumber: 4,
    monthName: 'Апрель',
    planFactData: null
  },
  {
    monthNumber: 5,
    monthName: 'Май',
    planFactData: null
  },
  {
    monthNumber: 6,
    monthName: 'Июнь',
    planFactData: null
  },
  {
    monthNumber: 7,
    monthName: 'Июль',
    planFactData: null
  },
  {
    monthNumber: 8,
    monthName: 'Август',
    planFactData: null
  },
  {
    monthNumber: 9,
    monthName: 'Сентябрь',
    planFactData: null
  },
  {
    monthNumber: 10,
    monthName: 'Октябрь',
    planFactData: null
  },
  {
    monthNumber: 11,
    monthName: 'Ноябрь',
    planFactData: null
  },
  {
    monthNumber: 12,
    monthName: 'Декабрь',
    planFactData: null
  },
]
